import React from "react";
import { Box, CircularProgress } from "@mui/material";
import FusionLoader from "components/common/FusionLoader";

export default ({ page, search, small = false }) => {
  // Full-page loading: fills and centers within the nearest positioned ancestor
  // (the dashboard's <main> content area, so it sits beside the sidebar — not
  // under it). Falls back to the viewport when rendered outside a positioned
  // container (e.g. pre-auth screens).
  if (page) {
    return (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <FusionLoader />
      </Box>
    );
  }

  // Search/inline loading: small, absolutely positioned
  if (search) {
    return (
      <CircularProgress
        color="primary"
        size={20}
        sx={{
          position: "absolute",
          top: "4px",
          right: "0.25em",
        }}
      />
    );
  }

  // Default: simple inline loading
  return <CircularProgress color="primary" size={small ? 30 : 48} />;
};
